import React from 'react';
import { useParams } from 'react-router-dom';
import AssetManagement from './AssetManagement';

/** Dedicated page for a single bespoke asset view (e.g. Stock) — not the main Assets module. */
const AssetViewPage: React.FC = () => {
  const { viewId } = useParams<{ viewId: string }>();
  if (!viewId) return null;
  return <AssetManagement standaloneViewId={viewId} />;
};

export default AssetViewPage;
